<div class="d-flex justify-content-end">

    <!-- open window button -->
    <div class="hidden-mobile hidden-tablet">
        <button class="filter-btn-wrapper" (click)="changePopWindowState()">
            <div class="d-flex text-center h-100">
                <div class="filter-btn-options filter-btn-title">Filtrar</div>
                <div *ngIf="!this.isPopUpOpen" class="filter-btn-options filter-btn-icons">
                    <img src="assets/imgs/filter-icon.png" class="filter-btn-img">
                </div>
                <div *ngIf="this.isPopUpOpen" class="filter-btn-options cancel-btn-icon filter-btn-icons">
                    <img src="assets/imgs/cancel-icon.png" class="filter-btn-img">
                </div>
            </div>
        </button>
    </div>

    <div class="hidden-web" >
        <button class="filter-btn-wrapper-mobile " *ngIf="!this.isPopUpOpen" (click)="changePopWindowState()">
            <div *ngIf="!this.isPopUpOpen" class="filter-btn-options filter-btn-icons">
                <img style="margin-bottom: 100%;" src="assets/imgs/filter-icon.png" class="filter-btn-img">
                
            </div>
    
        </button>
        <button class="filter-btn-wrapper-mobile " style="background: #e4ebf2;  "*ngIf="this.isPopUpOpen"  (click)="changePopWindowState()">
            <div *ngIf="this.isPopUpOpen"   class="filter-btn-options-close filter-btn-icons">
                <img class="filter-btn-options-movil" style="margin-bottom: 8px;" src="assets/imgs/cancel-icon.png">
            </div>
        </button>
    </div>

    <!-- pop up window -->
    <div [hidden]="!this.isPopUpOpen" class="pop-up-window">
        <div class='wrapper hidden-web hidden-tablet'>
            <div class="box div2">
                <div class="custom-form">
                    <p class="filter-modal-title"> Filtrar</p>
                </div>
            </div>

            <div class="box div3">
                <button class="filter-btn-wrapper-mobile-close"  (click)="changePopWindowState()">
                    <div *ngIf="this.isPopUpOpen">
                        <img src="assets/imgs/cancel-icon.png" class="filter-btn-options-movil">
                    </div>
                </button>
            </div>
        </div>
        <ng-container #filterForms></ng-container>


        <!-- filter submit button -->
        <div class="submit-btn-wrapper w-100 position-relative"> 
            <div class="submit-btn-wrapper-line ms-3"></div>
            <div class="d-flex align-items-center pb-4 ps-3 pe-3 pt-3">
                <div class="w-50 d-flex justify-content-start align-items-center delete-filters-wrapper"
                    (click)="cleanForm()">
                    <p class="mb-0 me-2 bs-text-roboto-alert">Borrar filtros</p>
                    <i class="fa fa-trash"></i>
                </div>
                <div class="w-50">
                    <button class="submit-button" (click)="executeSearch(false)">
                        APLICAR
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>